/** Id del contenitore principale del layout master: bersaglio del focus quando la sidebar si richiude con Escape. */
export const MASTER_MAIN_CONTENT_ID = 'master-main-content';
